import { render, staticRenderFns } from "./video.vue?vue&type=template&id=272d9d9f&scoped=true&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"
import style0 from "./video.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./video.vue?vue&type=style&index=1&id=272d9d9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272d9d9f",
  null
  
)

export default component.exports